export const getVehicleNadaVid = (state) => { var _a; return (_a = state.domain.vehicle) === null || _a === void 0 ? void 0 : _a.nadaVid; };
//# sourceMappingURL=getVehicleNadaVid.js.map